module.exports = __webpack_public_path__ + "img/ape-constructor-not-in-wallet.c1116f97.svg";